// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".65ed42f5abac151e60d0faa1f7c5b402.js";
};